import { generateMedia } from 'styled-media-query'

export const customMedia = generateMedia({
  xs: "599px",
  sm: "839px",
  md: "1023px",
  lg: "1024px"
});